import {Pagos} from './Pagos';
export default Pagos;